module.exports = "/365FarmNet/dist/bookingActivitiesPopup.b5003cb49139b053406c0e94f8daa8ca.html";